<script setup lang="ts">
import { API_URL } from '@Constants';

defineEmits(['deleteFile', 'hideFile']);

const props = withDefaults(
  defineProps<{
    actionsFilesModel?: string | null;
    canDelete?: boolean;
    hidden?: boolean;
    entityId: string;
    filename: string;
    filesProperties: any;
    index: number;
    path: string;
    shelterId?: string;
  }>(),
  {
    actionsFilesModel: null,
    canDelete: true,
    hidden: false,
  }
);

function sanitizeEntityPath() {
  return props.path
    ? props.path
    : `${API_URL}.s3.amazonaws.com/${props.shelterId}/${props.entityId}/images/${props.filename}`;
}
</script>

<template>
  <div class="group relative">
    <a
      v-tooltip.top="
        index === 0
          ? $t('animals.individualPage.profileInfo.profilePhoto') + ' - ' + filename
          : filename
      "
      class="relative flex h-20 w-20 items-center justify-evenly p-2"
      target="_blank"
      :href="sanitizeEntityPath()"
    >
      <AAvatar
        :class="[
          'h-full w-full border ',
          index === 0 ? 'border-af-purple-500' : 'border-brand-500',
        ]"
        :src="sanitizeEntityPath()"
      />

      <div
        v-if="props.hidden"
        class="pointer-events-none absolute z-10 flex h-[60px] w-[60px] items-center justify-center rounded-[50%] border bg-gray-400 bg-opacity-60"
      />
    </a>

    <Button
      v-if="canDelete && actionsFilesModel === 'hideUnhide'"
      v-tooltip.top="!props.hidden ? $t('common.active') : $t('common.hidden')"
      outlined
      class="absolute right-0 top-0 h-fit w-fit border-none p-0 hover:bg-sky-100"
      :icon="!props.hidden ? 'pi pi-eye' : 'pi pi-eye-slash'"
      severity="info"
      @click="$emit('hideFile', $event)"
    />

    <Button
      v-if="canDelete && actionsFilesModel === 'deleteImages'"
      outlined
      class="absolute right-0 top-0 h-fit w-fit border-none p-0 hover:bg-red-100"
      icon="pi pi-trash"
      severity="danger"
      @click="$emit('deleteFile', $event)"
    />
  </div>
</template>
